import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  FinancialYearDto,
  FinancialYearListDto,
  FinancialYearFilterDto,
  CreateFinancialYearRequest,
  UpdateFinancialYearRequest,
} from '@/types/financialYear.types';

export const financialYearApi = {
  /** GET /api/v1/financial-years — paginated list with optional search/filter */
  getList: (filter?: FinancialYearFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<FinancialYearListDto>>>('/financial-years', {
      params: filter,
    }),

  /** GET /api/v1/financial-years/{id} — full financial year record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<FinancialYearDto>>(`/financial-years/${id}`),

  /** GET /api/v1/financial-years/by-code/{code} — returns 404 when not found */
  getByCode: (code: string) =>
    apiClient.get<ApiResponse<FinancialYearDto>>(
      `/financial-years/by-code/${encodeURIComponent(code)}`,
    ),

  /** POST /api/v1/financial-years — create a new financial year */
  create: (data: CreateFinancialYearRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/financial-years', data),

  /** PUT /api/v1/financial-years/{id} — update financial year details */
  update: (id: string, data: UpdateFinancialYearRequest) =>
    apiClient.put<ApiResponse<object>>(`/financial-years/${id}`, data),

  /** DELETE /api/v1/financial-years/{id} — soft-delete the financial year */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/financial-years/${id}`),
};
